import type { AsyncThunk } from '@reduxjs/toolkit';
import { getBaseUrl, request } from 'src/helpers/thunkApi';


interface ThunkRejectValue {
  actionType?: string;
  status?: number;
  [key: string]: unknown;
}

type RequestThunk = AsyncThunk<unknown, unknown, { rejectValue: ThunkRejectValue }>;

export const fetchPartnerIntegration = (
  partner?: string,
  _params?: Record<string, unknown>,
): RequestThunk => request(
  {
    method: 'GET',
    url: `${getBaseUrl()}/api/integrations/${partner}/settings`,
    contentType: 'json',
    integrationApiKey: process.env.NEXT_PUBLIC_INTEGRATION_PUBLIC_API_KEY ?? '',
  },
  'partner-integration',
);

export const connectPartnerIntegration = (partner?: string): RequestThunk => request({
  method: 'POST',
  url: `${getBaseUrl()}/api/integrations/connect/${partner}`,
  contentType: 'json',
}, 'connect-partner-integration');
